import { createStore } from 'vuex';
import tmdbApi from './modules/tmdbApi';

let movie_store = localStorage.getItem('movie_store');
let view_set = 'grid';
if (movie_store) {
  movie_store = JSON.parse(movie_store);
  view_set = movie_store.view_set;
}

export default createStore({
  state: {
    release_btw: null,
    view: view_set,
    onMobile: null,
  },
  mutations: {
    releaseDate(state, dates) {
      state.release_btw = dates;
    },
    setView(state, prop) {
      let movie_store = localStorage.getItem('movie_store');
      if (movie_store) {
        movie_store = JSON.parse(movie_store);
      }
      let newStore = {
        ...movie_store,
        view_set: prop,
      };
      localStorage.setItem('movie_store', JSON.stringify(newStore));

      state.view = prop;
    },
    mobileView(state, prop) {
      state.onMobile = prop;
    },
  },
  actions: {
    getReleaseDate({ commit }, dates) {
      commit('releaseDate', dates);
    },
    setView({ commit }, prop) {
      commit('setView', prop);
    },
    mobileView({ commit }, prop) {
      commit('mobileView', prop);
    },
  },
  modules: { tmdbApi },
});
